import {
    Row,
    Button,
    Col,
    Form
} from "react-bootstrap";
import onGenerateInterlockReport from "../../services/Reports/GenerateInterlockReport";
import { useForm } from 'react-hook-form';
import React, { useState } from 'react';
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router-dom";

const GenerateInterlockReportModalForm = ({ id }) => {
    const { handleSubmit, register } = useForm();
    const [disableDownload, setDisableDownload] = useState(false);
    const [zipFile, setZipFile] = useState(null);
    const [excelFile, setExcelFile] = useState(null);

    const history = useHistory();

    const handleGenerateReport = (data) => {
        // Prepare form data to include files and parameters
        const formData = new FormData();
        if (zipFile) {
            formData.append('zip_file', zipFile, zipFile.name);
        }
        if (excelFile) {
            formData.append('csv_file', excelFile, excelFile.name);
        }
        onGenerateInterlockReport({
            id,
            formData,
            setDisableDownload,
            history,
        });
    };

    return (
        <Form className="FormGenerateReport" onSubmit={handleSubmit(handleGenerateReport)}>
            <div>
                <h5>Upload Files</h5>
                <Form.Group controlId="zipFile" className="mb-3">
                    <Form.Label>ZIP File</Form.Label>
                    <Form.Control
                        type="file"
                        accept=".zip"
                        {...register('zipFile')}
                        onChange={e => setZipFile(e.target.files[0])}
                    />
                </Form.Group>
                <Form.Group controlId="excelFile">
                    <Form.Label>Excel/CSV File</Form.Label>
                    <Form.Control
                        type="file"
                        accept=".xls,.xlsx,.csv"
                        {...register('excelFile')}
                        onChange={e => setExcelFile(e.target.files[0])}
                    />
                </Form.Group>
            </div>

            <Row>
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Button
                        disabled={disableDownload}
                        type="submit"
                        className="btn btn-green-theme w-100 mt-3"
                    >
                        {disableDownload ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{' '}
                                Downloading
                            </>
                        ) : (
                            'Download Report'
                        )}
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default GenerateInterlockReportModalForm;
